import type { AuthProviderError } from "../utils/auth"
import { useQuery } from "@tanstack/react-query"
import { decodeJwt } from "jose"
import { useSnackbar } from "notistack"
import useAuth from "../utils/auth"
import type { Permission } from "../utils/constants"
import { customQueryKeys } from "../utils/constants"

export function useGetPermissions() {
  const { getAccessTokenSilently, isAuthenticated, logout } = useAuth()
  const { enqueueSnackbar } = useSnackbar()
  return useQuery({
    queryKey: [
      customQueryKeys.permissions,
      isAuthenticated,
      getAccessTokenSilently,
      logout,
      enqueueSnackbar,
    ],
    queryFn: async () => {
      if (!isAuthenticated) {
        return []
      }
      try {
        const accessToken = await getAccessTokenSilently()
        const decoded = decodeJwt(accessToken)

        return (decoded.permissions as Permission[] | undefined) ?? []
      } catch (err) {
        const error = err as AuthProviderError
        if (
          error.error !== "login_required" &&
          error.error !== "interaction_required"
        ) {
          console.error(error)
          enqueueSnackbar("Failed to decode token", {
            variant: "error",
          })
        }
        // If we can't get a token, log the user out to reset their session
        void logout({ returnTo: window.location.origin })
        return []
      }
    },
    enabled: isAuthenticated,
  })
}
